<template>
    <div class="weui-cells weui-cells_form">
      <h3 class="page__title">用户列表检索</h3>
      
      <div class="weui-cell weui-cell_active weui-cell_vcode">
          <div class="weui-cell__hd">
              <label class="weui-label">昵称</label>
          </div>
          <div class="weui-cell__bd weui-cell__bd-WU">
              <input class="weui-input" style="text-align:center" type="text" placeholder="支持模糊检索,可只输入一部分" v-model="nickname"/>
          </div>
      </div>               
      <div class="weui-cell weui-cell_active weui-cell_vcode">
          <div class="weui-cell__hd">
              <label class="weui-label">手机</label>
          </div>
          <div class="weui-cell__bd weui-cell__bd-WU">
              <input class="weui-input" style="text-align:center" type="text" placeholder="支持模糊检索,可只输入一部分" v-model="mobile"/>
          </div>
      </div>              
      <div class="weui-cell weui-cell_active weui-cell_vcode">
          <div class="weui-cell__hd">
              <label class="weui-label">车牌</label>
          </div>
          <div class="weui-cell__bd weui-cell__bd-WU">
              <input class="weui-input" style="text-align:center" type="text" placeholder="支持模糊检索,可只输入一部分" v-model="plate"/>
          </div>
      </div>                   
      <div class="weui-cell weui-cell_active weui-cell_vcode">
          <div class="weui-cell__hd">
              <label class="weui-label">OPENID</label>
          </div>
          <div class="weui-cell__bd weui-cell__bd-WU">
              <input class="weui-input" style="text-align:center" type="text" placeholder="支持模糊检索,可只输入一部分" v-model="userAccount"/>
          </div>
      </div>      
   
      <div class="weui-cell weui-cell_active weui-cell_vcode">
          <div class="weui-cell__hd">
          </div>
          <div class="weui-cell__bd weui-cell__bd-WU">
            <a @click="getuserList" class="weui-btn weui-btn_primary">检索</a>
          </div>
      </div>          
      <div class="weui-msg" v-if="userList.length > 0">
        <div class="weui-form-preview" v-for="itm in userList" :key="itm.user_account">
            <div class="weui-form-preview__hd">
                <label class="weui-form-preview__label">用户昵称</label>
                <em class="weui-form-preview__value">【 {{itm.nickname}} 】</em>
            </div>
            <div class="weui-form-preview__bd">
                <div class="weui-form-preview__item">
                    <label class="weui-form-preview__label">OpenID</label>
                    <span class="weui-form-preview__value a_hot_touch"  @click="toUrl(itm.user_account)">{{itm.user_account}}</span>
                </div>
                <div class="weui-form-preview__item">
                    <label class="weui-form-preview__label">注册时间</label>
                    <span class="weui-form-preview__value">{{itm.create_time}}</span>
                </div>
                <div class="weui-form-preview__item">
                    <label class="weui-form-preview__label">最后修改</label>
                    <span class="weui-form-preview__value">{{itm.modify_time}}</span>
                </div>
                <div class="weui-form-preview__item">
                    <label class="weui-form-preview__label">用户手机</label>
                    <span class="weui-form-preview__value">{{itm.mobile}} </span>
                </div>
                <div class="weui-form-preview__item">
                    <label class="weui-form-preview__label">用户车牌</label>
                    <span class="weui-form-preview__value"> {{itm.plates}}</span>
                </div>
                <div class="weui-form-preview__item">
                    <label class="weui-form-preview__label">默认模式</label>
                    <span class="weui-form-preview__value"> {{getModeName(itm.car_wash_method)}}</span>
                </div>
                <div class="weui-form-preview__item">
                    <label class="weui-form-preview__label">链点</label>
                    <span class="weui-form-preview__value"> {{itm.point}}</span>
                </div>
                <div class="weui-form-preview__item">
                    <label class="weui-form-preview__label">余额</label>
                    <span class="weui-form-preview__value">￥{{itm.balance/100.00}}</span>
                </div>
                <div class="weui-form-preview__item">
                    <label class="weui-form-preview__label">旧余额</label>
                    <span class="weui-form-preview__value">￥{{itm.obalance/100.00}}</span>
                </div>
                <div class="weui-form-preview__item">
                    <label class="weui-form-preview__label">等级</label>
                    
                    <span class="weui-form-preview__value" v-if="itm.level == 3" >VIP-3</span>
                    <span class="weui-form-preview__value" v-else-if="itm.level == 2" >VIP-2</span>
                    <span class="weui-form-preview__value" v-else-if="itm.level == 1" >VIP-1</span>
                </div>
                <div class="weui-form-preview__item">
                    <label class="weui-form-preview__label">提醒内容</label>
                    <span class="weui-form-preview__value">
                      <input class="weui-input" style="text-align:center" type="text" placeholder="对服务如有疑惑，可通过公众号发送消息联系我们。" v-model="default_message" />
                    </span>
                </div>
                <div class="weui-form-preview__item">
                    <label class="weui-form-preview__label">提醒URL</label>
                    <span class="weui-form-preview__value">
                      <input class="weui-input" style="text-align:center" type="text" placeholder="填写ULR，默认到评价页面" v-model="default_url" />
                    </span>
                </div>
            </div>
            <div class="weui-form-preview__ft">
                
                <a class="weui-form-preview__btn weui-form-preview__btn_primary" @click="sendMsg(itm.user_account)">推送提醒消息</a>
            </div>
        </div>
      </div>
      <div class="weui-msg" v-else>
        <div class="weui-msg__icon-area"><i class="weui-icon-warn weui-icon_msg"></i></div>
        <div class="weui-msg__text-area">
            <h2 class="weui-msg__title">没有符合条件的用户</h2>
            <p class="weui-msg__desc">可修改检索条件，再次试试</p>
        </div>
      </div>
      <div id="loadingToast" style="display: none;" v-if="ing">
        <div class="weui-mask_transparent"></div>
        <div class="weui-toast">
            <span class="weui-primary-loading weui-primary-loading_transparent weui-icon_toast">
              <span class="weui-primary-loading__dot"></span>
            </span>
            <p class="weui-toast__content">加载中</p>
        </div>
    </div>
    <div role="alert" class="weui-toptips weui-toptips_warn" id="warnToast">{{this.errMsg}}</div>
    </div>
  </template>

<script>

import axios from "axios"
import { reduceRight } from "emojis-list";
import JQ from 'jquery'

function get2Str(str){
  return padding1(str,2);
}
function padding1(num, length) {
  for(var len = (num + "").length; len < length; len = num.length) {
   num = "0" + num;
  }
  return num;
 }
export default {
  data () {
    return {
      ing:true,
      default_message:"使用众敏洗车链服务，如有任何疑问或建议，均可直接在众敏洗车链公众号留言。或者点击此处反馈。我们将尽快回复您。",
      default_url:"https://zmxcl.nationaiot.com/customer/pageEntry?state=29",
      errMsg:"获取数据失败",
      userAccount:"",
      nickname:"",
      mobile:"",
      plate:"",
      date:new Date(),
      ing:true,
      userList : [],
    }
  },
  mounted() {
       if(this.$route.params.userAccount) this.userAccount = this.$route.params.userAccount;
       if(this.$route.params.nickname) this.nickname = this.$route.params.nickname;
       if(this.$route.params.mobile) this.mobile = this.$route.params.mobile;
       if(this.$route.params.plate) this.plate = this.$route.params.plate;

       this.getuserList();

  },
  methods: {       
   toUrl(openid){
      this.$router.push({name:"orderlist_user",params:{
        userAccount:openid
      }});
    },
    
    getModeName(sid){
      let sName = sid;
      switch(parseInt(sid)){
        case 1: sName = "超洗";break;
        case 2: sName = "精洗";break;
        case 3: sName = "精洗";break;
        case 4: sName = "快洗";break;
      }
      return sName;
    },    
    sendMsg(userAccount){
      //this.errMsg = ("发送信息暂未开放，建设中。");
      //this.showError();

      let paras = {};

      paras.openid = userAccount;
      paras.title = "众敏洗车链客服在线";
      paras.tname = "温馨提醒";
      paras.remark = this.default_message;
      paras.url = this.default_url;

      let that = this;
      axios.get('/zmomc/sendTemplateMsg', {
        params: paras
      })
      .then(function (response) {
        console.log(response.data);

        if(response.data == true){
          that.errMsg = ("发送成功");
          that.showTips();
        }

      })
      .catch(function (error) {
        console.log(error);
      })
      .then(function () {
        console.log("always exec")
      });  

    },
    showError(){
      var $warnToast = JQ('#warnToast');
      $warnToast.fadeIn(100);
      setTimeout(function () {
          $warnToast.fadeOut(100);
      }, 5000);
    },
    showTips(){
      var $warnToast = JQ('#warnToast');
      $warnToast.fadeIn(100);
      setTimeout(function () {
          $warnToast.fadeOut(100);
      }, 1000);
    },
    getuserList() {
      console.log("getuserList")
      this.ing=true
      this.userList=[];

      let paras = {};

      if(this.userAccount.length>0) paras.openid = this.userAccount;
      if(this.nickname.length>0) paras.nick = this.nickname;
      if(this.mobile.length>0) paras.phone = this.mobile;
      if(this.plate.length>0) paras.plate = this.plate;

      let that = this;
      axios.get('/zmomc/getUserListByComplex', {
        params: paras
      })
      .then(function (response) {
        console.log(response);
        that.userList = response.data

      })
      .catch(function (error) {
        console.log(error);
      })
      .then(function () {
        console.log("always exec")
        console.log(that.userList );
      });  
      this.ing=false
    }
  }
}
</script>

<style scoped>
.weui-cell__bd-WU{width: 60px !important}

.a_hot_touch{color:blue;font-style:italic;text-decoration:underline;}
</style>


// WEBPACK FOOTER //
// src/views/userlist.vue